import { mutateByPath } from "../../../utility";
import { ArsTableState, ArstActionPatchData, ArstActionPatchDataMultiple } from "../interface";
import { computeUsedGroupingFactorIds } from "./computeUsedGroupingFactorIds";

/**
 * Applies one or more body or scaffold patches to the ARS table state.
 *
 * @param state - Current ARS table state
 * @param action - Patch action containing one or more updates
 * @returns Updated ARS table state
 */
export const arst_patchData = <T>(
  state: ArsTableState<T>,
  action: ArstActionPatchData | ArstActionPatchDataMultiple,
): ArsTableState<T> => {
  let newBodyData = { ...state.bodyData };
  let scaffoldModel = state.scaffoldModel ? { ...state.scaffoldModel } : null;
  let calculatedTableRows = state.calculatedTableRows ? [...state.calculatedTableRows] : [];
  const updates =
    "updates" in action ? action.updates : [{ dataPath: action.dataPath, value: action.value }];

  for (const update of updates) {
    if (update.dataPath.startsWith("scaffoldModel")) {
      if (!scaffoldModel) continue;
      scaffoldModel = mutateByPath(
        scaffoldModel,
        update.dataPath.replace("scaffoldModel/", ""),
        update.value,
      );
    } else if (update.dataPath.startsWith("calculatedTableRows")) {
      calculatedTableRows = mutateByPath(
        calculatedTableRows,
        update.dataPath.replace("calculatedTableRows/", ""),
        update.value,
      );
    } else {
      newBodyData = mutateByPath(newBodyData, update.dataPath, update.value);
    }
  }

  return {
    ...state,
    bodyData: newBodyData,
    scaffoldModel,
    calculatedTableRows,
    usedGroupingFactorIds: computeUsedGroupingFactorIds(newBodyData),
    changed: true,
  };
};
